import createIcon from "../createIcon"

export const ChevronUpIcon = (props) => {
  return createIcon({
    size: props.size,
    path : <path fillRule="evenodd" clipRule="evenodd" d="M5.22781 15.7657C5.53155 16.0781 6.02401 16.0781 6.32775 15.7657L12 9.93137L17.6723 15.7657C17.976 16.0781 18.4685 16.0781 18.7722 15.7657C19.0759 15.4533 19.0759 14.9467 18.7722 14.6343L12.55 8.23431C12.2462 7.9219 11.7538 7.9219 11.45 8.23431L5.22781 14.6343C4.92406 14.9467 4.92406 15.4533 5.22781 15.7657Z" fill="#1A1818"/>
  })
} 